import { b as __awaiter, c as __generator, _ as _assign, d as __spreadArray } from './tslib.es6-c6da0ae6.js';
import noop from '@picsart/rc/noop';
import AnalyticsService from '@picsart/rc/services/analytics';
import fetcher from './fetcher/index.js';
import getDeviceId from './getDeviceId/index.js';
import getReCaptchaToken from './getReCaptchaToken/index.js';
import getResponseErrorMessage from './getResponseErrorMessage/index.js';
import IS_BROWSER from './isBrowser/index.js';
import { FACEBOOK_APP_ID, REGISTRATION_DONE, ANALYTICS_PLATFORM_TYPE, SOCIAL_REQUEST_HEADER_TOKEN, API_URL, ResponseStatus, REFRESH_TOKEN_URL } from './configs/constants/index.js';
import { F as FACEBOOK_PLATFORM_SCRIPT_URL, A as ANALYTICS_SCREEN_NAME_KEY, a as ANALYTICS_CONSENTS_KEY, C as ConsentType, b as AuthActionOptions, S as StatusOptions, c as SocialProviderOptions, d as AnalyticsActionOptions, e as ComponentsOptions, f as RegErrorReasons, g as AuthActionConfig } from './constants-e3c79897.js';
import { authStates, authStateKey } from './models/user/index.js';
import { useEffect } from 'react';
import useDelayedScript from './useDelayedScript/index.js';
import { setStorage, removeStorage } from './services/browserStorage/index.js';
import { authorizationHeader } from './services/auth/index.js';
import HttpService from './services/http/index.js';
import errorLogger, { BUGSNAG_STATUSES } from './services/errorLogger/index.js';

var handleFacebookResponse$1 = function handleFacebookResponse(observeUserData) {
  var _a, _b;
  (_b = (_a = window === null || window === void 0 ? void 0 : window.FB) === null || _a === void 0 ? void 0 : _a.login) === null || _b === void 0 ? void 0 : _b.call(_a, function (result) {
    if (result === null || result === void 0 ? void 0 : result.authResponse) {
      handleSocialRequestByProvider(result.authResponse.accessToken, 'facebook').then(function (userData) {
        if (userData === null || userData === void 0 ? void 0 : userData.token) {
          observeUserData(userData);
        }
        setStorage(authStateKey, authStates.authorized);
      })["catch"](function (error) {
        console.error('Error handling Facebook response:', error);
      });
    }
  }, {
    scope: 'email,public_profile'
  });
};
function useFacebookAuth(enable) {
  var isScriptLoaded = useDelayedScript(FACEBOOK_PLATFORM_SCRIPT_URL);
  useEffect(function () {
    if (enable) {
      if (!isScriptLoaded) {
        return;
      }
      window.fbAsyncInit = function () {
        window.FB.init({
          appId: FACEBOOK_APP_ID,
          cookie: true,
          xfbml: false,
          version: 'v21.0'
        });
      };
    }
  }, [enable, isScriptLoaded]);
}

var UserField;
(function (UserField) {
  UserField["name"] = "name";
  UserField["email"] = "email";
})(UserField || (UserField = {}));
var UserField$1 = UserField;

var UsernameSuggestion = function () {
  function UsernameSuggestion() {
    var _this = this;
    this.usernameSuggestionInfo = {
      data: '',
      userField: UserField$1.email
    };
    this.index = 0;
    this.suggestedUsernames = [];
    this.setUserData = function (data, userField) {
      _this.usernameSuggestionInfo.data = data;
      _this.usernameSuggestionInfo.userField = userField;
    };
    this.suggest = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              if (!(!this.suggestedUsernames.length || this.index === this.suggestedUsernames.length)) return [3, 2];
              return [4, suggestUsername(this.usernameSuggestionInfo)];
            case 1:
              response = _a.sent().response;
              this.setSuggestedUsernames(response);
              this.index = 0;
              _a.label = 2;
            case 2:
              return [2, this.suggestedUsernames[this.index++]];
          }
        });
      });
    };
    this.setSuggestedUsernames = function (usernames) {
      _this.suggestedUsernames = usernames;
    };
    this.getUsernameSuggestionInfo = function () {
      return _this.usernameSuggestionInfo;
    };
    this.getSuggestedUsernames = function () {
      return _this.suggestedUsernames;
    };
  }
  return UsernameSuggestion;
}();
var usernameSuggestion = new UsernameSuggestion();

var data = {
  title: 'To get started:',
  privacyPolicy: 'TERMS_OF_USE_KR',
  ariaLabelPrivacyPolice: 'Read our privacy policy',
  mandatory: [{
    id: '1',
    consent: 'terms_of_use_consent',
    label: 'I have read and agree to the Terms of Use.'
  }, {
    id: '2',
    consent: 'above_14_age_consent',
    label: 'I confirm that I am 14 years or older.'
  }, {
    id: '3',
    consent: 'mandatory_pii_consent',
    label: 'I consent to the mandatory collection and use of personal information:',
    description: 'MANDATORY_PII_CONSENT'
  }],
  optionalTitle: 'Optional:',
  optional: [{
    id: '4',
    consent: 'optional_pii_consent',
    label: 'I consent to the optional collection and use of personal information:',
    description: 'OPTIONAL_PII_CONSENT'
  }, {
    id: '5',
    consent: 'pii_usage_and_collect_consent',
    label: 'I consent to the optional collection and use of personal information for receiving updates on Picsart products, services and events:',
    description: 'PII_USAGE_AND_COLLECT_CONSENT'
  }, {
    id: '6',
    consent: 'pii_usage_consent',
    label: 'I consent to receiving updates on Picsart products, services and events:',
    description: 'PII_USAGE_CONSENT'
  }]
};

var GoogleCallbackSource;
(function (GoogleCallbackSource) {
  GoogleCallbackSource["Button"] = "btn";
  GoogleCallbackSource["OneTap"] = "user";
})(GoogleCallbackSource || (GoogleCallbackSource = {}));

var fireCombinedAnalytics = function fireCombinedAnalytics(_a) {
  var _b, _c, _d;
  var action = _a.action,
    userData = _a.userData,
    triggeredFrom = _a.triggeredFrom,
    socialName = _a.socialName,
    isAuthCombined = _a.isAuthCombined,
    select_by = _a.select_by,
    flow = _a.flow,
    _e = _a.fromWelcomeBack,
    fromWelcomeBack = _e === void 0 ? false : _e;
  var id = (userData === null || userData === void 0 ? void 0 : userData.id) || ((_b = userData.user) === null || _b === void 0 ? void 0 : _b.id);
  var email = (userData === null || userData === void 0 ? void 0 : userData.email) || ((_c = userData.user) === null || _c === void 0 ? void 0 : _c.email);
  var name = (_d = userData.user) === null || _d === void 0 ? void 0 : _d.name;
  try {
    if ((userData === null || userData === void 0 ? void 0 : userData.registered) && socialName) {
      AnalyticsService.pushDataLayer({
        event: 'complete_registration'
      });
    }
    AnalyticsService.pushDataLayer({
      event: 'gtm_set',
      data: {
        parameters: {
          gtm_userID: id,
          gtm_userEmail: email || '',
          gtm_userName: name || ''
        }
      }
    });
    AnalyticsService.pushDataLayer({
      pulse: 'state',
      user_id: id
    });
    AnalyticsService.sendEvent(REGISTRATION_DONE, {
      provider: socialName !== null && socialName !== void 0 ? socialName : 'Picsart',
      registration_type: select_by === GoogleCallbackSource.OneTap ? 'google_one_tap' : 'standard',
      braze: true,
      action_button: triggeredFrom,
      action: action,
      fromWelcomeBack: fromWelcomeBack,
      flow: flow,
      flow_type: isAuthCombined && 'monetization_combined',
      platform: ANALYTICS_PLATFORM_TYPE
    }, undefined, 2);
    removeStorage(ANALYTICS_SCREEN_NAME_KEY, false);
    removeStorage(ANALYTICS_CONSENTS_KEY, false);
  } catch (error) {
    console.error('Error firing analytics:', error);
    errorLogger.trigger(error, BUGSNAG_STATUSES.ERROR);
  }
};

var MILLISECONDS_PER_SECOND = 1000;
var SECONDS_PER_MINUTE = 60;
var LOCALE = 'en-US';
var formatter = new Intl.DateTimeFormat(LOCALE, {
  timeZone: 'UTC',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  fractionalSecondDigits: 3,
  hour12: false
});
var isDateLessThanOneMinute = function isDateLessThanOneMinute(dateString) {
  var now = new Date();
  var date = new Date(dateString);
  var utcDateStr = formatter.format(date);
  var utcNowStr = formatter.format(now);
  var utcDate = new Date(utcDateStr);
  var utcNow = new Date(utcNowStr);
  var diffInMilliSeconds = utcNow.getTime() - utcDate.getTime();
  var diffInMinutes = Math.round(diffInMilliSeconds / MILLISECONDS_PER_SECOND / SECONDS_PER_MINUTE);
  return diffInMinutes < 1;
};

var sharedAnalytics = function sharedAnalytics(_a) {
  var _b, _c, _d, _e, _f, _g;
  var view = _a.view,
    data = _a.data,
    setErrorMessage = _a.setErrorMessage,
    onSuccess = _a.onSuccess,
    triggeredFrom = _a.triggeredFrom,
    _h = _a.isSocial,
    isSocial = _h === void 0 ? false : _h,
    socialName = _a.socialName,
    flow = _a.flow;
  onSuccess && (data === null || data === void 0 ? void 0 : data.user) && onSuccess((data === null || data === void 0 ? void 0 : data.user) || data, data === null || data === void 0 ? void 0 : data.removal_info);
  !isSocial && AnalyticsService.sendEvent('popup_action', {
    name: view && (data === null || data === void 0 ? void 0 : data.registered) ? 'sign_up' : 'sign_in',
    action: 'action_button'
  });
  if ((data === null || data === void 0 ? void 0 : data.registered) && isSocial) {
    AnalyticsService.pushDataLayer({
      event: 'complete_registration'
    });
  }
  AnalyticsService.pushDataLayer({
    event: 'gtm_set',
    data: {
      parameters: {
        gtm_userID: (data === null || data === void 0 ? void 0 : data.id) || ((_b = data.user) === null || _b === void 0 ? void 0 : _b.id) || ((_c = data.response) === null || _c === void 0 ? void 0 : _c.id),
        gtm_userEmail: (data === null || data === void 0 ? void 0 : data.email) || ((_d = data.user) === null || _d === void 0 ? void 0 : _d.email) || ((_e = data.response) === null || _e === void 0 ? void 0 : _e.email) || '',
        gtm_userName: ((_f = data === null || data === void 0 ? void 0 : data.user) === null || _f === void 0 ? void 0 : _f.name) || ''
      }
    }
  });
  AnalyticsService.pushDataLayer({
    pulse: 'state',
    user_id: (data === null || data === void 0 ? void 0 : data.id) || ((_g = data.user) === null || _g === void 0 ? void 0 : _g.id)
  });
  var accountCreatedAtTimeStamp = data === null || data === void 0 ? void 0 : data.created;
  var isNewlyCreatedUser = accountCreatedAtTimeStamp && isDateLessThanOneMinute(accountCreatedAtTimeStamp);
  AnalyticsService.sendEvent(REGISTRATION_DONE, {
    provider: socialName !== null && socialName !== void 0 ? socialName : 'Picsart',
    action: view || isNewlyCreatedUser ? 'sign_up' : 'sign_in',
    registration_type: 'standard',
    braze: true,
    action_button: triggeredFrom,
    flow: flow,
    platform: ANALYTICS_PLATFORM_TYPE
  }, function () {
    !isSocial && setErrorMessage && setErrorMessage('');
  });
};

var headers = _assign({
  platform: 'website',
  'g-recaptcha-token': '',
  'g-recaptcha-action': '',
  'Content-Type': 'application/json',
  token: SOCIAL_REQUEST_HEADER_TOKEN
}, getDeviceId() && {
  deviceid: getDeviceId()
});
var socialHeaders = _assign({
  'Content-Type': 'application/json',
  'token-type': 'JWT',
  platform: 'website'
}, getDeviceId() && {
  deviceid: getDeviceId()
});
var mandatory = data.mandatory,
  optional = data.optional;
var consents = __spreadArray(__spreadArray(__spreadArray([], mandatory, true), optional, true), [{
  id: ConsentType.biometric,
  consent: ConsentType.biometric
}, {
  id: ConsentType.marketing,
  consent: ConsentType.marketing
}], false);
var getIsMaximizer = function getIsMaximizer() {
  if (!IS_BROWSER) return false;
  var _a = window.location,
    pathname = _a.pathname,
    search = _a.search;
  var queryParams = new URLSearchParams(search);
  var isMaximizer = queryParams.get('maximizer') === 'true';
  return isMaximizer || pathname.includes('admaker') || pathname.includes('marketing');
};
var getConsents = function getConsents(checkedStates) {
  return checkedStates && consents.filter(function (item) {
    return checkedStates[item.id];
  }).map(function (item) {
    return item.consent;
  });
};
var emailCodeSendRequest = function emailCodeSendRequest(_a) {
  var preventReCaptcha = _a.preventReCaptcha,
    email = _a.email;
  return new Promise(function (resolve, reject) {
    var emailCodeSendInner = function emailCodeSendInner() {
      return __awaiter(void 0, void 0, void 0, function () {
        var recaptchaResponse, status_1, token, err_1, data_1, status_2, err_2;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              if (!!preventReCaptcha) return [3, 4];
              _a.label = 1;
            case 1:
              _a.trys.push([1, 3,, 4]);
              return [4, getReCaptchaToken(AuthActionOptions.SignIn)];
            case 2:
              recaptchaResponse = _a.sent();
              status_1 = recaptchaResponse.status, token = recaptchaResponse.token;
              if (status_1 === ResponseStatus.success) {
                headers['g-recaptcha-token'] = token;
                headers['g-recaptcha-action'] = AuthActionOptions.SignIn;
              }
              return [3, 4];
            case 3:
              err_1 = _a.sent();
              reject(new Error(getResponseErrorMessage(err_1)));
              return [3, 4];
            case 4:
              _a.trys.push([4, 6,, 7]);
              return [4, fetcher("".concat(API_URL, "/user-account/auth/signin/code/send"), {
                method: 'POST',
                body: JSON.stringify({
                  email: email
                }),
                headers: headers,
                credentials: 'include'
              })];
            case 5:
              data_1 = _a.sent();
              status_2 = data_1.status;
              if (status_2 === ResponseStatus.success) {
                resolve({
                  type: StatusOptions.Success,
                  message: data_1
                });
              }
              return [3, 7];
            case 6:
              err_2 = _a.sent();
              reject(new Error(getResponseErrorMessage(err_2)));
              return [3, 7];
            case 7:
              return [2];
          }
        });
      });
    };
    emailCodeSendInner();
  });
};
var signInTokenRequest = function signInTokenRequest(token) {
  return HttpService.post("".concat(API_URL, "/user-account/auth/token"), {
    token: token
  }, {
    headers: {
      platform: 'website'
    },
    credentials: 'include'
  });
};
var handleSubmitRequest = function handleSubmitRequest(_a) {
  var flow = _a.flow,
    body = _a.body,
    action = _a.action,
    onSuccess = _a.onSuccess,
    onTerminatedAccount = _a.onTerminatedAccount,
    triggeredFrom = _a.triggeredFrom,
    setServerStatus = _a.setServerStatus,
    reCaptchaToken = _a.reCaptchaToken,
    isAuthCombined = _a.isAuthCombined,
    externalProvider = _a.externalProvider,
    fromWelcomeBack = _a.fromWelcomeBack,
    _b = _a.checkBiometricState,
    checkBiometricState = _b === void 0 ? false : _b;
  return __awaiter(void 0, void 0, void 0, function () {
    var _c, analyticName, endpoint, bodyData, isMaximizer;
    return __generator(this, function (_d) {
      switch (_d.label) {
        case 0:
          _c = AuthActionConfig[action], analyticName = _c.analyticName, endpoint = _c.endpoint;
          headers['g-recaptcha-action'] = action;
          headers['g-recaptcha-token'] = reCaptchaToken;
          bodyData = body;
          if (action === AuthActionOptions.SignUp) {
            isMaximizer = getIsMaximizer();
            if (isMaximizer) {
              bodyData.redirectAfterEmailConfirmation = "".concat(window.location.origin, "/create?maximizer=true");
            }
          }
          delete bodyData.isLocal;
          if (action === AuthActionOptions.SignIn) {
            delete bodyData.email;
          }
          AnalyticsService.sendEvent('popup_action', {
            name: analyticName,
            action: 'action_button'
          });
          setServerStatus({
            type: StatusOptions.Submitting
          });
          return [4, fetcher("".concat(API_URL, "/").concat(endpoint), {
            method: 'POST',
            body: JSON.stringify(bodyData),
            headers: _assign(_assign({}, headers), {
              'check-biometric-consent': checkBiometricState.toString()
            }),
            credentials: 'include'
          }).then(function (data) {
            return __awaiter(void 0, void 0, void 0, function () {
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    if (!((data === null || data === void 0 ? void 0 : data.status) === ResponseStatus.success)) return [3, 2];
                    return [4, fireCombinedAnalytics({
                      flow: flow,
                      action: analyticName,
                      userData: data,
                      triggeredFrom: triggeredFrom,
                      socialName: externalProvider,
                      isAuthCombined: isAuthCombined,
                      fromWelcomeBack: fromWelcomeBack
                    })];
                  case 1:
                    _a.sent();
                    onSuccess((data === null || data === void 0 ? void 0 : data.user) || data, data === null || data === void 0 ? void 0 : data.removal_info);
                    return [3, 6];
                  case 2:
                    if (!(data === null || data === void 0 ? void 0 : data.removal_info)) return [3, 5];
                    if (!onTerminatedAccount) return [3, 4];
                    return [4, onTerminatedAccount(data.removal_info)];
                  case 3:
                    _a.sent();
                    _a.label = 4;
                  case 4:
                    return [3, 6];
                  case 5:
                    setServerStatus({
                      type: StatusOptions.Error,
                      message: data === null || data === void 0 ? void 0 : data.message,
                      reason: data === null || data === void 0 ? void 0 : data.reason
                    });
                    _a.label = 6;
                  case 6:
                    return [2];
                }
              });
            });
          })["catch"](function (err) {
            setServerStatus({
              statusCode: err.statusCode,
              type: StatusOptions.Error,
              message: getResponseErrorMessage(err),
              reason: (err === null || err === void 0 ? void 0 : err.reason) || ''
            });
          })];
        case 1:
          _d.sent();
          return [2];
      }
    });
  });
};
var handleSubmit = function handleSubmit(_a) {
  var flow = _a.flow,
    email = _a.email,
    username = _a.username,
    password = _a.password,
    code = _a.code,
    preventReCaptcha = _a.preventReCaptcha,
    action = _a.action,
    checkUser = _a.checkUser,
    onTerminatedAccount = _a.onTerminatedAccount,
    triggeredFrom = _a.triggeredFrom,
    setServerStatus = _a.setServerStatus,
    checkedStates = _a.checkedStates,
    isAuthCombined = _a.isAuthCombined,
    redirectAfterEmailConfirmation = _a.redirectAfterEmailConfirmation,
    externalProvider = _a.externalProvider,
    fromWelcomeBack = _a.fromWelcomeBack,
    checkBiometricState = _a.checkBiometricState;
  var consents = getConsents(checkedStates);
  var reqData = {
    password: password,
    redirectAfterEmailConfirmation: redirectAfterEmailConfirmation
  };
  if (action === AuthActionOptions.SignUp) {
    reqData = _assign(_assign(_assign({}, reqData), {
      email: email
    }), {
      consents: consents
    });
  } else if (action === AuthActionOptions.SignInWithCode) {
    reqData = _assign(_assign(_assign(_assign({}, reqData), {
      email: email
    }), {
      code: code
    }), {
      provider: externalProvider
    });
  } else {
    reqData = _assign(_assign({}, reqData), {
      username: username || email
    });
  }
  if (action === AuthActionOptions.SignIn || action === AuthActionOptions.SignInWithCode) {
    if (!preventReCaptcha) {
      getReCaptchaToken(action).then(function (_a) {
        var status = _a.status,
          token = _a.token;
        if (status === ResponseStatus.success) {
          handleSubmitRequest({
            flow: flow,
            body: reqData,
            action: action,
            onSuccess: checkUser,
            setServerStatus: setServerStatus,
            onTerminatedAccount: onTerminatedAccount,
            triggeredFrom: triggeredFrom,
            reCaptchaToken: token,
            isAuthCombined: isAuthCombined,
            fromWelcomeBack: fromWelcomeBack,
            externalProvider: externalProvider,
            checkBiometricState: checkBiometricState
          });
        }
      })["catch"](function (err) {
        setServerStatus === null || setServerStatus === void 0 ? void 0 : setServerStatus({
          type: StatusOptions.Error,
          message: getResponseErrorMessage(err)
        });
      });
    } else {
      handleSubmitRequest({
        flow: flow,
        body: reqData,
        action: action,
        onSuccess: checkUser,
        onTerminatedAccount: onTerminatedAccount,
        triggeredFrom: triggeredFrom,
        setServerStatus: setServerStatus,
        isAuthCombined: isAuthCombined,
        externalProvider: externalProvider,
        checkBiometricState: checkBiometricState
      });
    }
  } else if (!preventReCaptcha) {
    getReCaptchaToken(action).then(function (_a) {
      var status = _a.status,
        token = _a.token;
      if (status === ResponseStatus.success) {
        handleSubmitRequest({
          flow: flow,
          body: reqData,
          action: AuthActionOptions.SignUp,
          onSuccess: checkUser,
          setServerStatus: setServerStatus,
          onTerminatedAccount: onTerminatedAccount,
          triggeredFrom: triggeredFrom,
          reCaptchaToken: token,
          isAuthCombined: isAuthCombined,
          externalProvider: externalProvider,
          checkBiometricState: checkBiometricState
        });
      }
    })["catch"](function (err) {
      setServerStatus === null || setServerStatus === void 0 ? void 0 : setServerStatus({
        type: StatusOptions.Error,
        message: getResponseErrorMessage(err)
      });
    });
  } else {
    handleSubmitRequest({
      flow: flow,
      body: reqData,
      action: AuthActionOptions.SignUp,
      onSuccess: checkUser,
      onTerminatedAccount: onTerminatedAccount,
      triggeredFrom: triggeredFrom,
      setServerStatus: setServerStatus,
      isAuthCombined: isAuthCombined,
      externalProvider: externalProvider,
      checkBiometricState: checkBiometricState
    });
  }
};
var handleSocialSignIn = function handleSocialSignIn(_a) {
  var socialName = _a.socialName,
    flow = _a.flow,
    checkUser = _a.checkUser,
    triggeredFrom = _a.triggeredFrom,
    _b = _a.userData,
    userData = _b === void 0 ? null : _b;
    _a.isAuthCombined;
  return function (e) {
    e === null || e === void 0 ? void 0 : e.preventDefault();
    if (!IS_BROWSER) {
      return;
    }
    handleBearerSocialSignIn(socialName, flow, userData, true, checkUser, triggeredFrom)(e);
  };
};
var handleSocialData = function handleSocialData(socialName, flow, data, isSignUpView, checkUser, triggeredFrom) {
  if (data && data.status === ResponseStatus.success) {
    sharedAnalytics({
      view: isSignUpView,
      data: {
        user: data
      },
      setErrorMessage: noop,
      onSuccess: checkUser,
      triggeredFrom: triggeredFrom,
      isSocial: true,
      socialName: socialName,
      flow: flow
    });
  } else {
    throw new Error('userData is Empty');
  }
};
var handleBearerSocialSignIn = function handleBearerSocialSignIn(socialName, flow, userData, isSignUpView, checkUser, triggeredFrom) {
  return function (e) {
    e === null || e === void 0 ? void 0 : e.preventDefault();
    if (IS_BROWSER) {
      var data_2 = userData;
      setStorage(authStateKey, authStates.authorized);
      if (socialName === 'facebook') {
        var observeUserData = function observeUserData(userSocialData) {
          data_2 = userSocialData;
          handleSocialData(socialName, flow, data_2, isSignUpView, checkUser, triggeredFrom);
        };
        handleFacebookResponse$1(observeUserData);
        return;
      }
      handleSocialData(socialName, flow, data_2, isSignUpView, checkUser, triggeredFrom);
    }
  };
};
var handleConsentConfirmation = function handleConsentConfirmation(_a) {
  var isConsentReached = _a.isConsentReached,
    accessToken = _a.accessToken,
    countryCode = _a.countryCode;
  return __awaiter(void 0, void 0, void 0, function () {
    var consent;
    var _b;
    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          switch (countryCode) {
            case 'kr':
              consent = 'above_14_age_consent';
              break;
            case 'us':
              consent = 'terms_and_condition_consent';
              break;
            default:
              consent = 'above_14_age_consent';
          }
          return [4, HttpService.post("".concat(API_URL, "/users/consent"), (_b = {}, _b[consent] = isConsentReached, _b), {
            logErrors: true,
            headers: _assign(_assign({}, authorizationHeader(accessToken)), {
              'content-type': 'application/json',
              'country-code': countryCode
            })
          })["catch"](console.error)];
        case 1:
          _c.sent();
          return [2];
      }
    });
  });
};
var handleNewSocialRequest = function handleNewSocialRequest(_a) {
  var flow = _a.flow,
    credential = _a.credential,
    provider = _a.provider,
    username = _a.username,
    checkUser = _a.checkUser,
    checkedStates = _a.checkedStates,
    setCurrentPage = _a.setCurrentPage,
    setUsername = _a.setUsername,
    triggeredFrom = _a.triggeredFrom,
    onClick = _a.onClick,
    isAuthCombined = _a.isAuthCombined,
    select_by = _a.select_by,
    _b = _a.fromWelcomeBack,
    fromWelcomeBack = _b === void 0 ? false : _b,
    _c = _a.checkBiometricState,
    checkBiometricState = _c === void 0 ? false : _c;
  return __awaiter(void 0, void 0, void 0, function () {
    var processedCheckedStates, consents;
    var _d;
    return __generator(this, function (_e) {
      switch (_e.label) {
        case 0:
          processedCheckedStates = select_by === GoogleCallbackSource.OneTap ? _assign(_assign({}, checkedStates), (_d = {}, _d[ConsentType.biometric] = true, _d)) : checkedStates;
          consents = getConsents(processedCheckedStates);
          return [4, HttpService.post("".concat(API_URL, "/user-account/auth/social"), {
            provider: SocialProviderOptions[provider],
            data: {
              token: credential
            },
            consents: consents,
            username: username || undefined
          }, {
            logErrors: true,
            headers: _assign(_assign({}, socialHeaders), {
              'check-biometric-consent': checkBiometricState.toString()
            }),
            credentials: 'include'
          }).then(function (data) {
            var user = data.user,
              removal_info = data.removal_info,
              status = data.status;
            if (status === ResponseStatus.success) {
              fireCombinedAnalytics({
                flow: flow,
                action: (data === null || data === void 0 ? void 0 : data.registered) ? AnalyticsActionOptions.SignUp : AnalyticsActionOptions.SignIn,
                userData: data,
                triggeredFrom: triggeredFrom,
                socialName: SocialProviderOptions[provider],
                isAuthCombined: isAuthCombined,
                select_by: select_by,
                fromWelcomeBack: fromWelcomeBack
              });
              checkUser((data === null || data === void 0 ? void 0 : data.user) || data, data === null || data === void 0 ? void 0 : data.removal_info);
              onClick === null || onClick === void 0 ? void 0 : onClick(SocialProviderOptions[provider], user)(null);
            } else {
              checkUser(user, removal_info);
            }
          })["catch"](function (err) {
            return __awaiter(void 0, void 0, void 0, function () {
              var error, username_1;
              return __generator(this, function (_b) {
                switch (_b.label) {
                  case 0:
                    return [4, err.json()];
                  case 1:
                    error = _b.sent();
                    if (!(error.reason === RegErrorReasons.Consents && setCurrentPage)) return [3, 6];
                    if (!!error.missingConsents.includes(ConsentType.biometric)) return [3, 2];
                    setCurrentPage(ComponentsOptions.ToGetStarted);
                    return [3, 6];
                  case 2:
                    _b.trys.push([2, 4,, 5]);
                    usernameSuggestion.setUserData(error.email ? error.email : error.name, error.email ? UserField$1.email : UserField$1.name);
                    return [4, usernameSuggestion.suggest()];
                  case 3:
                    username_1 = _b.sent();
                    setUsername(username_1);
                    return [3, 5];
                  case 4:
                    _b.sent();
                    setUsername === null || setUsername === void 0 ? void 0 : setUsername(error.email);
                    return [3, 5];
                  case 5:
                    setCurrentPage(ComponentsOptions.UsernameFormSSO);
                    _b.label = 6;
                  case 6:
                    console.error('handleNewSocialRequest -', err);
                    return [2];
                }
              });
            });
          })];
        case 1:
          _e.sent();
          return [2];
      }
    });
  });
};
function handleSocialRequestByProvider(credential, provider, redirectAfterEmailConfirmation) {
  return __awaiter(this, void 0, void 0, function () {
    var response, result, error_1;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 3,, 4]);
          return [4, fetcher("".concat(API_URL, "/user-account/auth/social"), {
            body: JSON.stringify({
              provider: provider,
              redirectAfterEmailConfirmation: redirectAfterEmailConfirmation,
              data: {
                token: credential
              }
            }),
            credentials: 'include',
            headers: socialHeaders,
            method: 'POST'
          })];
        case 1:
          response = _a.sent();
          if (!response.ok) {
            throw new Error("Failed to fetch: ".concat(response.statusText));
          }
          return [4, response.json()];
        case 2:
          result = _a.sent();
          return [2, result];
        case 3:
          error_1 = _a.sent();
          console.error('Error in handleSocialRequestByProvider:', error_1);
          throw error_1;
        case 4:
          return [2];
      }
    });
  });
}
var handleAppleRequest = function handleAppleRequest(_a) {
  var flow = _a.flow,
    appleData = _a.appleData,
    checkUser = _a.checkUser,
    triggeredFrom = _a.triggeredFrom,
    setCurrentPage = _a.setCurrentPage,
    checkedStates = _a.checkedStates,
    setSocialData = _a.setSocialData,
    setUsername = _a.setUsername,
    isAuthCombined = _a.isAuthCombined,
    fromWelcomeBack = _a.fromWelcomeBack,
    checkBiometricState = _a.checkBiometricState;
  return __awaiter(void 0, void 0, void 0, function () {
    var data, id_token, _b;
    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          data = appleData && appleData.authorization;
          id_token = data.id_token;
          setSocialData && setSocialData({
            provider: SocialProviderOptions.apple,
            credential: id_token
          });
          _b = data && !appleData.error;
          if (!_b) return [3, 2];
          return [4, handleNewSocialRequest({
            flow: flow,
            credential: id_token,
            provider: SocialProviderOptions.apple,
            checkUser: checkUser,
            checkedStates: checkedStates,
            setCurrentPage: setCurrentPage,
            setUsername: setUsername,
            triggeredFrom: triggeredFrom,
            isAuthCombined: isAuthCombined,
            fromWelcomeBack: fromWelcomeBack,
            checkBiometricState: checkBiometricState
          })];
        case 1:
          _b = _c.sent();
          _c.label = 2;
        case 2:
          return [2];
      }
    });
  });
};
var handleGoogleResponse = function handleGoogleResponse(_a) {
  var flow = _a.flow,
    accountData = _a.accountData,
    checkUser = _a.checkUser,
    triggeredFrom = _a.triggeredFrom,
    onClick = _a.onClick,
    checkedStates = _a.checkedStates,
    setCurrentPage = _a.setCurrentPage,
    setSocialData = _a.setSocialData,
    setUsername = _a.setUsername,
    isAuthCombined = _a.isAuthCombined,
    fromWelcomeBack = _a.fromWelcomeBack,
    checkBiometricState = _a.checkBiometricState;
  return __awaiter(void 0, void 0, void 0, function () {
    var credential, select_by;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          if (!(accountData === null || accountData === void 0 ? void 0 : accountData.credential)) {
            throw Error('Empty account data!');
          }
          setTimeout(function () {
            if (accountData.credential) {
              setSocialData && setSocialData({
                provider: SocialProviderOptions.google,
                credential: accountData.credential
              });
            }
          }, 100);
          credential = accountData.credential, select_by = accountData.select_by;
          return [4, handleNewSocialRequest({
            flow: flow,
            credential: credential,
            provider: SocialProviderOptions.google,
            checkUser: checkUser,
            checkedStates: checkedStates,
            setCurrentPage: setCurrentPage,
            setUsername: setUsername,
            triggeredFrom: triggeredFrom,
            onClick: onClick,
            isAuthCombined: isAuthCombined,
            select_by: select_by,
            fromWelcomeBack: fromWelcomeBack,
            checkBiometricState: checkBiometricState
          })];
        case 1:
          _b.sent();
          return [2];
      }
    });
  });
};
var handleFacebookResponse = function handleFacebookResponse(_a) {
  var _b, _c;
  var flow = _a.flow,
    checkUser = _a.checkUser,
    triggeredFrom = _a.triggeredFrom,
    checkedStates = _a.checkedStates,
    setCurrentPage = _a.setCurrentPage,
    setSocialData = _a.setSocialData,
    setUsername = _a.setUsername,
    isAuthCombined = _a.isAuthCombined,
    fromWelcomeBack = _a.fromWelcomeBack,
    checkBiometricState = _a.checkBiometricState;
  var fbScope = {
    scope: 'email,public_profile,user_photos',
    auth_type: 'rerequest'
  };
  (_c = (_b = window === null || window === void 0 ? void 0 : window.FB) === null || _b === void 0 ? void 0 : _b.login) === null || _c === void 0 ? void 0 : _c.call(_b, function (result) {
    return __awaiter(void 0, void 0, void 0, function () {
      var error_2;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 3,, 4]);
            if (!(result === null || result === void 0 ? void 0 : result.authResponse)) return [3, 2];
            setSocialData && setSocialData({
              provider: SocialProviderOptions.facebook,
              credential: result.authResponse.accessToken
            });
            return [4, handleNewSocialRequest({
              flow: flow,
              credential: result.authResponse.accessToken,
              provider: SocialProviderOptions.facebook,
              checkUser: checkUser,
              checkedStates: checkedStates,
              setCurrentPage: setCurrentPage,
              setUsername: setUsername,
              triggeredFrom: triggeredFrom,
              isAuthCombined: isAuthCombined,
              fromWelcomeBack: fromWelcomeBack,
              checkBiometricState: checkBiometricState
            })];
          case 1:
            _a.sent();
            _a.label = 2;
          case 2:
            return [3, 4];
          case 3:
            error_2 = _a.sent();
            console.error('Error in handleFacebookResponse:', error_2);
            return [3, 4];
          case 4:
            return [2];
        }
      });
    });
  }, fbScope);
};
var updateUsername = function updateUsername(_a) {
  var data = _a.data,
    accessToken = _a.accessToken,
    preventReCaptcha = _a.preventReCaptcha;
  return __awaiter(void 0, void 0, void 0, function () {
    var recaptchaResponse, status_3, token, err_3, res, status_4, err_4;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          if (!!preventReCaptcha) return [3, 4];
          _b.label = 1;
        case 1:
          _b.trys.push([1, 3,, 4]);
          return [4, getReCaptchaToken(AuthActionOptions.SignIn)];
        case 2:
          recaptchaResponse = _b.sent();
          status_3 = recaptchaResponse.status, token = recaptchaResponse.token;
          if (status_3 === ResponseStatus.success) {
            headers['g-recaptcha-token'] = token;
            headers['g-recaptcha-action'] = AuthActionOptions.SignIn;
          }
          return [3, 4];
        case 3:
          err_3 = _b.sent();
          throw new Error(getResponseErrorMessage(err_3));
        case 4:
          _b.trys.push([4, 6,, 7]);
          return [4, fetcher("".concat(API_URL, "/users/update.json"), {
            method: 'POST',
            body: JSON.stringify(data),
            headers: _assign(_assign(_assign({}, headers), {
              platform: 'website'
            }), authorizationHeader(accessToken)),
            credentials: 'include'
          })];
        case 5:
          res = _b.sent();
          status_4 = res.status;
          if (status_4 === ResponseStatus.success) {
            return [2, {
              type: StatusOptions.Success,
              message: res
            }];
          }
          return [3, 7];
        case 6:
          err_4 = _b.sent();
          throw new Error(getResponseErrorMessage(err_4));
        case 7:
          return [2];
      }
    });
  });
};
var checkUsername = function checkUsername(username) {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [2, fetcher("".concat(API_URL, "/users/revise/username.json"), {
        method: 'POST',
        body: JSON.stringify({
          username: username
        }),
        headers: headers
      })];
    });
  });
};
var suggestUsername = function suggestUsername(ssoInfo) {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [2, fetcher("".concat(API_URL, "/users/usernames/suggest.json?").concat(ssoInfo.userField, "=").concat(ssoInfo.data), {
        method: 'GET',
        headers: headers
      })];
    });
  });
};
var userLogout = function userLogout(accessToken) {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [2, fetch("".concat(API_URL, "/users/signout.json"), {
        method: 'POST',
        headers: _assign({
          platform: 'website'
        }, authorizationHeader(accessToken)),
        credentials: 'include',
        body: JSON.stringify({})
      })];
    });
  });
};
var refreshTokenRequest = function refreshTokenRequest(headers, getRefreshTokenHeader) {
  if (headers === void 0) {
    headers = {};
  }
  if (getRefreshTokenHeader === void 0) {
    getRefreshTokenHeader = null;
  }
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [2, fetch(REFRESH_TOKEN_URL, {
        headers: _assign(_assign({
          'content-type': 'application/json',
          platform: 'website'
        }, getDeviceId() && {
          deviceid: getDeviceId()
        }), headers),
        credentials: 'include',
        body: JSON.stringify({}),
        method: 'POST'
      }).then(function (res) {
        var _a;
        if (res.status >= 400) {
          throw new Error(res.status.toString());
        }
        getRefreshTokenHeader === null || getRefreshTokenHeader === void 0 ? void 0 : getRefreshTokenHeader((_a = res === null || res === void 0 ? void 0 : res.headers) === null || _a === void 0 ? void 0 : _a.get('set-cookie'));
        return res.json();
      })["catch"](function (err) {
        throw err;
      })];
    });
  });
};
var refreshToken = function refreshToken(headers, getRefreshTokenHeader) {
  if (headers === void 0) {
    headers = {};
  }
  if (getRefreshTokenHeader === void 0) {
    getRefreshTokenHeader = null;
  }
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [2, refreshTokenRequest(headers, getRefreshTokenHeader)["catch"](function () {
        return refreshTokenRequest(headers, getRefreshTokenHeader);
      })];
    });
  });
};
function getUser(accessToken) {
  return __awaiter(this, void 0, void 0, function () {
    var userData;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4, fetch("".concat(API_URL, "/users/show/me.json?email_encoded=1"), {
            headers: authorizationHeader(accessToken),
            priority: 'high'
          })];
        case 1:
          userData = _a.sent();
          return [2, userData.json()];
      }
    });
  });
}

export { UserField as U, handleNewSocialRequest as a, usernameSuggestion as b, handleAppleRequest as c, handleGoogleResponse as d, handleFacebookResponse as e, handleSocialSignIn as f, getUser as g, handleConsentConfirmation as h, handleSubmit as i, emailCodeSendRequest as j, useFacebookAuth as k, data as l, updateUsername as m, checkUsername as n, refreshToken as r, signInTokenRequest as s, userLogout as u };
//# sourceMappingURL=requestFactory-4dc9ec32.js.map
